"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _components = require("@engaging-tech/components");
var _routing = require("@engaging-tech/routing");
var _useNavContext2 = _interopRequireDefault(require("../../hooks/useNavContext"));
var _AnimatedStarIcon = _interopRequireDefault(require("./AnimatedStarIcon"));
var Wrapper = (0, _styledComponents["default"])(_components.Flex).withConfig({
  displayName: "PremiumLink__Wrapper",
  componentId: "sc-6fm932-0"
})(["cursor:pointer;"]);
var PremiumLink = function PremiumLink(_ref) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  var _useNavContext = (0, _useNavContext2["default"])(),
    premiumRoute = _useNavContext.premiumRoute;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, premiumRoute && /*#__PURE__*/_react["default"].createElement(_routing.Link, (0, _extends2["default"])({
    to: premiumRoute.path
  }, premiumRoute.linkProps), /*#__PURE__*/_react["default"].createElement(Wrapper, (0, _extends2["default"])({
    bg: "primary.0",
    borderRadius: 99,
    height: 34,
    width: 145,
    alignItems: "center",
    elevation: 0,
    mr: 2,
    my: 3,
    px: 2
  }, props), /*#__PURE__*/_react["default"].createElement(_AnimatedStarIcon["default"], {
    color: "yellow.0"
  }), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    color: "yellow.0",
    fontWeight: "700",
    fontSize: 3,
    fontFamily: "Centra",
    mr: 1,
    ml: 2
  }, premiumRoute.description))));
};
var _default = exports["default"] = PremiumLink;